<template>
	<div class="nutrition">
		<!-- <div class="header">
			<div class="back" @click="handleBack">返回</div>
		</div> -->
		<div class="item">
			<div class="title">总能量</div>
			<div class="pro">
				<van-progress :stroke-width="6" track-color="#f5f6f9" :percentage="0" :show-pivot="false"/>
				<div class="dot first"></div>
				<div class="dot last"></div>
				<div v-if="allEnergy.value<33.3" class="tip poor" :style="{'left': allEnergy.value+'%'}">{{ allEnergy.message }}</div>
				<div v-else-if="allEnergy.value>=33.3 && allEnergy.value<66.6" class="tip good" :style="{'left': allEnergy.value+'%'}">{{ allEnergy.message }}</div>
				<div v-else-if="allEnergy.value>=66.6" class="tip more" :style="{'left': allEnergy.value+'%'}">{{ allEnergy.message }}</div>
			</div>
			<div class="text">
				<div :class="{'active': allEnergy.value<33.3}">不足</div>
				<div :class="{'active': allEnergy.value>=33.3 && allEnergy.value<66.6}">适量</div>
				<div :class="{'active': allEnergy.value>=66.6}">过量</div>
			</div>
		</div>
		<div class="con">
			<div class="title">能量分布</div>
			<div class="ele" v-for="ele in proteinrSourceDTOList" :key="ele.name">
				<div class="left">{{ ele.name }}</div>
				<div class="right">
					<div class="pro">
						<van-progress :stroke-width="6" track-color="#f5f6f9" :percentage="0" :show-pivot="false"/>
						<div class="dot first"></div>
						<div class="dot last"></div>
						<div v-if="ele.value<33.3" class="tip poor" :style="{'left': ele.value+'%'}">{{ ele.message }}</div>
						<div v-else-if="ele.value>=33.3 && ele.value<66.6" class="tip good" :style="{'left': ele.value+'%'}">{{ ele.message }}</div>
						<div v-else-if="ele.value>=66.6" class="tip more" :style="{'left': ele.value+'%'}">{{ ele.message }}</div>
					</div>
					<div class="text">
						<div :class="{'active': ele.value<33.3}">不足</div>
						<div :class="{'active': ele.value>=33.3 && ele.value<66.6}">适量</div>
						<div :class="{'active': ele.value>=66.6}">过量</div>
					</div>
				</div>
			</div>
		</div>
		<div class="item">
			<div class="title">优质蛋白质</div>
			<div class="pro">
				<van-progress :stroke-width="6" track-color="#f5f6f9" :percentage="0" :show-pivot="false"/>
				<div class="dot first" style="left: 50%"></div>
				<div v-if="goodNut.realValue<goodNut.u1*100" class="tip poor" :style="{'left': goodNut.value+'%'}">{{ goodNut.message }}</div>
				<div v-else-if="goodNut.realValue > goodNut.u1*100" class="tip good" :style="{'left': goodNut.value+'%'}">{{ goodNut.message }}</div>
			</div>
			<div class="text">
				<div :class="{'active': goodNut.realValue<goodNut.u1*100}">不足</div>
				<div :class="{'active': goodNut.realValue> goodNut.u1*100}">适量</div>
			</div>
		</div>
		<div class="con">
			<div class="title">其它营养</div>
			<div class="ele" v-for="ele in nutritionContentDTOList" :key="ele.name">
				<div class="left">{{ ele.name }}</div>
				<div class="right">
					<div class="pro">
						<van-progress :stroke-width="6" track-color="#f5f6f9" :percentage="0" :show-pivot="false"/>
						<div class="dot first"></div>
						<div class="dot last"></div>
						<div v-if="ele.value<33.3" class="tip poor" :style="{'left': ele.value+'%'}">{{ ele.message }}</div>
						<div v-else-if="ele.value>=33.3 && ele.value<66.6" class="tip good" :style="{'left': ele.value+'%'}">{{ ele.message }}</div>
						<div v-else-if="ele.value>=66.6" class="tip more" :style="{'left': ele.value+'%'}">{{ ele.message }}</div>
					</div>
					<div class="text">
						<div :class="{'active': ele.value<33.3}">不足</div>
						<div :class="{'active': ele.value>=33.3 && ele.value<66.6}">适量</div>
						<div :class="{'active': ele.value>=66.6}">过量</div>
					</div>
				</div>
			</div>
		</div>
		<div class="item" style="margin-bottom: 0;">
			<div class="title">食物种类</div>
			<div class="pro">
				<van-progress :stroke-width="6" track-color="#f5f6f9" :percentage="0" :show-pivot="false"/>
				<div class="dot first" style="left: 50%"></div>
				<div v-if="foodNumber.realValue<foodNumber.dris" class="tip poor" :style="{'left': foodNumber.percent+'%'}">{{ foodNumber.message }}</div>
				<div v-else-if="foodNumber.realValue> foodNumber.dris" class="tip good" :style="{'left': foodNumber.percent+'%'}">{{ foodNumber.message }}</div>
			</div>
			<div class="text">
				<div :class="{'active': foodNumber.realValue<foodNumber.dris}">不足</div>
				<div :class="{'active': foodNumber.realValue> foodNumber.dris}">适量</div>
			</div>
		</div>
	</div>
</template>
<script>
import {score} from '@/api/searchFoods'
export default{
	name: 'nutrition',
	data(){
		return{
			propObj: {
				'201': '钙',
				'301': '铁',
				'303': '锌',
				'304': '硒',
				'204': '钠',
				'401': '维生素A',
				'405': '维生素B1',
				'406': '维生素B2',
				'415': '维生素C',
				'403': '维生素E',
				'501': '膳食纤维',

				'102': '蛋白质',
				'103': '脂肪',
				'104': '碳水化合物',
			},
			sunList: [
				{
					name: '严重不足',
					color: '#E02020',
				},
				{
					name: '不足',
					color: '#F7B500',
				},
				{
					name: '适量',
					color: '#2EAC9D',
				},
				{
					name: '过量',
					color: '#F7B500',
				},
				{
					name: '严重过量',
					color: '#E02020',
				}
			],
			sunList2: [
				{
					name: '严重不足',
					color: '#E02020',
				},
				{
					name: '不足',
					color: '#F7B500',
				},
				{
					name: '适量',
					color: '#2EAC9D',
				}
			],
			nutritionContentDTOList: [],
			proList: [],
			proteinrSourceDTOList: [],
			allEnergy: null,
			foodNumber: null,
			goodNut: null
		}
	},
	mounted(){
		const {id,tenantId} = this.$route.query
		this.getScore(id,tenantId)
	},
	methods:{
		// handleBack(){
		// 	this.$router.back()
		// },
		// 根据食谱id获取食谱评分
		async getScore(id,tenantId) {
      try {
        const { data } = await score(id, tenantId)
				this.formatEleven(data.data)
				this.formatThree(data.data)
				this.formatEnergy(data.data)
				this.formatFoodNumber(data.data)
				this.formatWellNut(data.data)
      } catch (error) {
        console.log(error)
      }
    },
		// 处理11种营养素
		formatEleven(data){
			let arr1 = data.nutritionContentDTOList;
			this.nutritionContentDTOList = []
			// 适量：U2-U3
			// 过量：u3-u4
			// 严重过量：> U4
			// 不足：U1-U2
			// 严重不足：<u1
			for (var i = 0; i < arr1.length; i++) {
				// let u1 = arr1[i].u1*100;
				let u2 = arr1[i].u2*100;
				let u3 = arr1[i].u3*100;
				// let u4 = arr1[i].u4*100;
				let num = parseFloat(arr1[i].realDris);
				let bz = parseFloat(arr1[i].recommendValueCount).toFixed(1);
				let j = {
					name: this.propObj[arr1[i].nutirtionId],
					message: bz == 0 ? '过量' : num.toFixed(1) + '%',
				}
				if(num < u2){
					j.bag = this.sunList[1].color;
					j.value = ((num*0.33/u2)*100).toFixed(1);
				}else if(num >= u2 && num <= u3){
					j.bag = this.sunList[2].color;
					j.value = ((num*0.66/u3)*100).toFixed(1);
				}else if(num > u3){
					j.bag = this.sunList[4].color;
					j.value = ((num/u3)*100).toFixed(1)>100? 100 : ((num/u3)*100).toFixed(1);
				}
				this.nutritionContentDTOList.push(j);
			}
		},
		// 处理三大营养素
		formatThree(data){
			let arr2 = data.proteinrSourceDTOList
			console.log(arr2)
			for (let i = 0; i < arr2.length; i++) {
				let u2Value = parseFloat(arr2[i].u2);
				let u3Value = parseFloat(arr2[i].u3);
				// let u1 = parseFloat(arr2[i].u1);
				let u2 = parseFloat(arr2[i].u2);
				let u3 = parseFloat(arr2[i].u3);
				// let u4 = parseFloat(arr2[i].u4);
				let percentNum =  i == 1 ? 9:4;
				//需量
				let powerTarget = parseFloat(data.recipeCalDTOList[0].powerTarget);
				let target =  powerTarget/percentNum * (u2Value + u3Value)/2;
				let nowPercent = arr2[i].value / target * 100;
				let j = {};
				j = {
					name: this.propObj[arr2[i].nutrientId],
					message: powerTarget == 0 ? '过量' : nowPercent.toFixed(1) + '%',
					bag:this.sunList[2].color,
				}
				//处理最右边值
				if(nowPercent >= 200){
					j.bag=this.sunList[4].color;
					j.value=100;
				}else{
					let value = nowPercent/100 * 90;
					if(value<0){
						value = 0;
					}else if(value > 90){
						value = 90;
					}
					j.value = value;
				}
				let num = arr2[i].real;
				//严重不足
				if(num< u2){
					j.bag=this.sunList[2].color;
					j.value=((num*0.33/u2)*100).toFixed(1);
				}else if(num >= u2 && num <= u3){
					j.bag=this.sunList[3].color;
					j.value=((num*0.66/u3)*100).toFixed(1);
				}else if(num > u3){
					j.bag=this.sunList[4].color;
					j.value=((num/u3)*100).toFixed(1)>100? 100 : ((num/u3)*100).toFixed(1);
				}
				this.proteinrSourceDTOList.push(j);
			}
		},
		// 处理总能量
		formatEnergy(data){
			const obj = data.recipeCalDTOList[0];
			// let u1 = obj.u1*100;
			let u2 = obj.u2*100;
			let u3 = obj.u3*100;
			// let u4 = obj.u4*100;
			let num = parseFloat(obj.percent);
			obj.message = obj.powerTarget === 0? '过量' :  num.toFixed(1) + '%';
			if(obj.powerTarget == 0){
				obj.bag = this.sunList[4].color;
				obj.value = 100;
			}else{
				//严重不足
				if(num< u2){
					obj.bag = this.sunList[2].color;
					obj.value = ((num*0.33/u2)*100).toFixed(1);
				}else if(num >= u2 && num <= u3){
					obj.bag = this.sunList[3].color;
					obj.value = ((num*0.66/u3)*100).toFixed(1);
				}else if(num > u3){
					obj.bag = this.sunList[4].color;
					obj.value = ((num/u3)*100).toFixed(1)>100? 100 : ((num/u3)*100).toFixed(1);
				}
			}
			this.allEnergy = obj
		},
		// 处理优质蛋白质
		formatWellNut(data){
			const goodProteinDTO = data.goodProteinDTOList[0];
			let u1 = goodProteinDTO.u1*100;
			let num = parseFloat(goodProteinDTO.real);
			goodProteinDTO.message = num.toFixed(1) + '%';
			if(num>=u1){
				goodProteinDTO.bag = this.sunList[2].color;
				goodProteinDTO.value = ((num/u1)*100)>100? 100: ((num/u1)*100).toFixed(1);
			}else {
				goodProteinDTO.bag = this.sunList[1].color;
				goodProteinDTO.value = ((num/u1)*100)>100? 100: ((num/u1)*100).toFixed(1);
			}
			this.goodNut = goodProteinDTO
		},
		// 食物种类
		formatFoodNumber(data){
			let fsd = data.foodSpeciesDTOList[0];
			let percent = (fsd.realValue * 100 / fsd.dris)>100? 100:fsd.realValue * 100 / fsd.dris;
			fsd.percent = percent
			fsd.message = fsd.realValue+"种";
			this.foodNumber = fsd
		}
	}
}
</script>
<style lang="less" scoped>
.nutrition{
	box-sizing: border-box;
	padding: 0.24rem 0;
	background-color: #f5f6f7;
	.header{
		padding: 0 0.32rem;
		display: flex;
		align-items: center;
		height: 0.88rem;
		.back{
			position: relative;
			display: flex;
			align-items: center;
			padding-left: 0.32rem;
			font-size: 0.32rem;
			color: #666;
			height: 100%;
			line-height: 100%;
		}
		.back::before{
			position: absolute;
			left: 0rem;
			top: -0.03rem;
			content: '<';
			width: 0.32rem;
			height: 0.32rem;
			line-height: 0.88rem;
			color: #666;
		}
	}
	.item{
		margin: 0 0.24rem 0.24rem;
		padding: 0.24rem;
		background-color: #fff;
		border-radius: 0.12rem;
		.title{
			margin-bottom: 0.64rem;
			color: #212121;
			font-weight: 600;
			font-size: 0.32rem;
		}
		.pro{
			position: relative;
			margin: 0 0.16rem;
			.dot{
				position: absolute;
				top:0;
				width: 0.04rem;
				height: 0.12rem;
				background-color: #c3c3c3;
				border-radius: 0.04rem;
			}
			.tip{
				position: absolute;
				top: 0;
				left:0;
				padding: 0.06rem 0.12rem;
				border-radius: 0.4rem;
				font-size: 0.20rem;
				color: #fff;
				width: max-content;
				transform: translate(-50%,calc(-100% - 0.13rem));
			}
			.poor{
				position: absolute;
				background-color: #F7B500;
			}
			.poor::after{
				content: "";
				width: 0;
				height: 0;
				border-top: 0.1rem solid #F7B500;
				border-left: 0.1rem solid transparent;
				border-right: 0.1rem solid transparent;
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translate(-50%,100%);
			}
			.good{
				position: absolute;
				background-color: #2EAC9D;
			}
			.good::after{
				content: "";
				width: 0;
				height: 0;
				border-top: 0.1rem solid #2EAC9D;
				border-left: 0.1rem solid transparent;
				border-right: 0.1rem solid transparent;
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translate(-50%,100%);
			}
			.more{
				position: absolute;
				background-color: #E02020;
			}
			.more::after{
				content: "";
				width: 0;
				height: 0;
				border-top: 0.1rem solid #E02020;
				border-left: 0.1rem solid transparent;
				border-right: 0.1rem solid transparent;
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translate(-50%,100%);
			}
			.first{
				left:33.3%;
			}
			.last{
				right: 33.3%;
			}
		}
		.text{
			padding: 0 0.16rem;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 0.64rem;
			.active{
				color: #212121;
			}
			div{
				height: 0.64rem;
				line-height: 0.64rem;
				flex:1;
				text-align: center;
				font-size: 0.24rem;
				color: #666;
			}
		}
	}
	.con{
		margin: 0 0.24rem 0.24rem;
		padding: 0.24rem;
		background-color: #fff;
		border-radius: 0.12rem;
		.title{
			margin-bottom: 0.64rem;
			color: #212121;
			font-weight: 600;
			font-size: 0.32rem;
		}
		.ele{
			display: flex;
			margin: 0.3rem 0 0.64rem 0;
			margin-bottom: 0.8rem;
			justify-content: space-between;
			.left{
				width: 1.6rem;
				font-size: 0.28rem;
				font-weight: 500;
			}
			.right{
				margin-top: 0.12rem;
				flex: 1;
				.pro{
					margin: 0 0.16rem;
					position: relative;
					.tip{
						width: max-content;
						position: absolute;
						top: 0;
						left:0;
						padding: 0.06rem 0.12rem;
						border-radius: 0.4rem;
						font-size: 0.20rem;
						color: #fff;
						transform: translate(-50%,calc(-100% - 0.13rem));
					}
					.poor{
						position: absolute;
						background-color: #F7B500;
					}
					.poor::after{
						content: "";
						width: 0;
						height: 0;
						border-top: 0.1rem solid #F7B500;
						border-left: 0.1rem solid transparent;
						border-right: 0.1rem solid transparent;
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translate(-50%,100%);
					}
					.good{
						position: absolute;
						background-color: #2EAC9D;
					}
					.good::after{
						content: "";
						width: 0;
						height: 0;
						border-top: 0.1rem solid #2EAC9D;
						border-left: 0.1rem solid transparent;
						border-right: 0.1rem solid transparent;
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translate(-50%,100%);
					}
					.more{
						position: absolute;
						background-color: #E02020;
					}
					.more::after{
						content: "";
						width: 0;
						height: 0;
						border-top: 0.1rem solid #E02020;
						border-left: 0.1rem solid transparent;
						border-right: 0.1rem solid transparent;
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translate(-50%,100%);
					}
					.dot{
						position: absolute;
						top:0;
						width: 0.04rem;
						height: 0.12rem;
						background-color: #c3c3c3;
						border-radius: 0.04rem;
					}
					.first{
						left:33.3%;
					}
					.last{
						right: 33.3%;
					}
				}
				.text{
					padding: 0 0.16rem;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 0.64rem;
					.active{
						color: #212121;
					}
					div{
						height: 0.64rem;
						line-height: 0.64rem;
						flex:1;
						text-align: center;
						font-size: 0.24rem;
						color: #666;
					}
				}
			}
		}
		.ele:last-child{
			margin-bottom: 0;
		}
	}
}
</style>